import CryptoDetail from "./CryptoDetail"; 
const SelectedCrypto = ({className, selectedCrypto, handleSelectCrypto, cryptos, loading, CryptoList, position})=>{
  console.log('checking position from selectedCrypto'); 
  console.log(position); 
  return (
	 <>
		<div className={`${className ? className: "" } grid grid-cols-1 md:grid-2 overflow-scroll`}>
          <div className={`col-span-1 ${selectedCrypto ? 'md:col-span-5' : 'md:col-span-9'}`}>
            <div className="bg-white p-6 rounded-lg shadow-md">
              {loading ? (
                <div className="flex justify-center items-center h-64">
                  <div className="text-xl">Loading...</div>
                </div>
              ) :(
                <CryptoList cryptos={cryptos} onSelect={handleSelectCrypto} />
              )}
            </div>
          </div>
          {selectedCrypto && (
            <div className="col-span-1 md:col-span-4">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h4 className="text-xl font-semibold mb-4">Details</h4>
                <CryptoDetail crypto={selectedCrypto} position = {position} />
              </div>
            </div>
          )}
        </div>

	 </>
  ); 
}
export default SelectedCrypto; 
